
import { Vue, Component, Prop, Model } from 'nuxt-property-decorator';
import { InputSelect } from 'fourwaves-shared/components';
import MoneyInput from '~/components/form/MoneyInput.vue';
import { InputOption } from 'fourwaves-shared';

@Component({
  components: {
    InputSelect,
    MoneyInput,
  },
})
export default class CheckoutMaxEventSelect extends Vue {
  @Prop({ type: Number, required: true }) readonly orgActiveEvent!: number;
  @Prop({ type: Number, required: true }) readonly maxActiveEvent!: number;
  @Prop(Boolean) readonly hasPayingPlan!: boolean;
  @Prop(Boolean) readonly customPlanMode!: boolean;
  @Prop(Boolean) readonly renew!: boolean;
  @Prop(Boolean) readonly disabled!: boolean;

  @Model('change', { type: Number, default: null }) readonly value!: number;

  get greaterBetweenOrgAndMaxActiveEvent() {
    if (!this.hasPayingPlan) return this.orgActiveEvent;
    return Math.max(this.orgActiveEvent, this.maxActiveEvent);
  }

  get options() {
    const options: InputOption[] = [];

    for (let i = 1; i <= 10; i++) {
      const label = i > 2 ? `${i} ${this.$t('checkout.max_event_select.discount')}` : String(i);
      options.push({
        id: i,
        label,
        disabled: i < this.greaterBetweenOrgAndMaxActiveEvent,
      });
    }
    return options;
  }

  get isInputSelectVisible() {
    if (this.customPlanMode) return false;
    if (!this.hasPayingPlan) return true;
    return this.hasPayingPlan && this.maxActiveEvent < 11;
  }

  get customModeValidation() {
    const minValue = this.renew ? 1 : this.greaterBetweenOrgAndMaxActiveEvent;
    return {
      required: true,
      min_value: minValue,
    };
  }
}
